export enum HipaaStatus {
  Unknown = 0,
  Yes = 1,
  No = 2
}
